import { FC } from "react";
import { Datagrid, List, ReferenceField, TextField } from "react-admin";

import CustomPagination from "../../components/CustomPagination";
import EmptyDataText from "../../components/EmptyDataText";
import TimestampField from "../../components/TimestampField";
import useCurrentUser from "../../hooks/useCurrentUser";
import useUpdateListNotifications from "../../hooks/useUpdateListNotifications";
import { AppResource } from "../../types/resource.types";
import { brandDocRef } from "../../utils/referencies";
import ExpectedDeliveryDate from "./components/ExpectedDeliveryDate";
import ListFormattedPrice from "./components/ListFormattedPrice";
import ListRowActions from "./components/ListRowActions";
import OrdersFilters from "./components/OrdersFilter";
import OrdersStatusText from "./components/OrdersStatusText";

const OrdersList: FC<any> = (props) => {
  const { user } = useCurrentUser();

  useUpdateListNotifications(brandDocRef(user.id as string), AppResource.orders, AppResource.ordersLastSeenAt);

  return (
    <List
      {...props}
      sort={{ field: "createdAt", order: "desc" }}
      pagination={<CustomPagination />}
      bulkActionButtons={false}
      exporter={false}
      filters={<OrdersFilters />}
    >
      <Datagrid empty={<EmptyDataText message="No orders yet!" />}>
        <TextField source="code" label="Code" sortable={false} />
        <ReferenceField
          label="Client"
          source="clientId"
          reference={`${AppResource.clients}`}
          sortable={false}
          link={false}
        >
          <TextField source="displayName" />
        </ReferenceField>
        <TextField source="deliveryMethod" label="Delivery Method" sortable={false} />
        <TextField source="paymentMethod" label="Payment Method" sortable={false} />
        <ListFormattedPrice source="totalPrice" label="Total Price" sortable={false} />
        <ExpectedDeliveryDate source="expectedDeliveryDate" label="Expected Delivery Date" sortable={false} />
        <TimestampField source="createdAt" label="Created At" />
        <OrdersStatusText source="status" label="Status" sortable={false} />
        <ListRowActions />
      </Datagrid>
    </List>
  );
};

export default OrdersList;
